export default function MuiToolbar() {
  return {
    MuiToolbar: {
      styleOverrides: {
        root: {
          "@media (min-width: 600px)": {
            minHeight: "55px",
          },
        },
      },
    },
  };
}
